<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <router-link to="/">{{ $t('menu.dashboard') }}</router-link>/
        <router-link to="/kampanya/listesi">{{ $t('menu.campaigns') }}</router-link>
        / {{ form.name }}
      </div>
      <div class="va-card__header-actions" />
    </template>
    <form @submit.prevent="onsubmit">
      <div class="row">
        <div class="flex md6 xs12">
          <div
            v-if="!!campaign.image_paths_readable && !!campaign.image_paths_readable.en"
            class="row"
          >
            <div class="flex xs12 text--center">
              <img
                :src="campaign.image_paths_readable.en"
                style="width:100%;height:auto;max-width:900px;max-height:450px"
              />
            </div>
          </div>
          <div class="row">
            <div class="flex xs12 text--center">
              <input
                type="file"
                name="image"
                accept="image/*"
                style="display:none"
                ref="campaignInputFileEn"
                @change="setImage"
              />
              <va-button
                type="button"
                small
                color="warning"
                @click.stop="handleFileInput"
                v-text="!!form.image_url ? 'Yerine Fotoğraf Seç' : 'Fotoğraf Seç'"
              />
            </div>
          </div>
        </div>
        <div class="flex md6 xs12">
          <div class="row">
            <div
              v-if="!!image && JSON.stringify(image) !== JSON.stringify({})"
              class="flex xs12 text--center"
            >
              <vue-cropper
                ref="cropper"
                :src="image.url"
                :rotatable="true"
                :view-mode="2"
                :aspectRatio="9/4"
                drag-mode="crop"
                outputSize="0.6"
                v-model="croppaImage"
                :img-style="{'width': '100%', 'height': '100%', 'max-width': '900px', 'max-height': '450px'}"
                :width="900"
                :height="450"
                :accept="'image/*'"
                :file-size-limit="1500000"
              />
              <va-popover message="Resmi Döndür" placement="bottom" :disabled="isMobile">
                <va-button
                  type="button"
                  small
                  color="info"
                  icon="fa fa-rotate-left"
                  @click.stop="rotateCroppaImage()"
                >Döndür</va-button>
              </va-popover>
              <va-popover message="Resmi Sil" placement="bottom" :disabled="isMobile">
                <va-button
                  type="button"
                  small
                  color="danger"
                  icon="fa fa-close"
                  @click.stop="deleteCroppaImage()"
                >Sil</va-button>
              </va-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="flex lg7 md6 xs12">
          <div class="row">
            <div class="flex xs12">
              <va-input
                v-model="form.title"
                label="Başlık [EN]"
                placeholder="Kampanya başlığı çevirisi girin"
              />
            </div>
            <div class="flex xs12">
              <va-input
                type="textarea"
                :min-rows="4"
                v-model="form.description"
                label="Açıklama [EN]"
                placeholder="Kampanya açıklaması çevirisi girin"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import campaignServices from "../../services/api/campaign";
import uploadServices from "../../services/api/upload";
import responseMixin from "../../services/api/response";
import helperMixin from "../../services/helper";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  mixins: [responseMixin, helperMixin],
  components: { VueCropper },
  computed: {
    isDisabled: function() {
      return this.hasSaved;
    }
  },
  data() {
    return {
      hasSaved: false,
      isMobile: false,
      campaignId: "",
      campaign: {},
      form: {
        language: "en",
        title: "",
        description: "",
        image: "",
        vehicles: []
      },
      croppaImage: {},
      image: {}
    };
  },
  methods: {
    clear(field) {
      this[field] = "";
    },
    async getCampaign() {
      const result = await campaignServices.get(this.campaignId, {
        params: {
          include: "vehicles",
          language: "en"
        }
      });
      this.campaign = result.data.data;
      this.fillCampaign(this.campaign);
    },
    async fillCampaign(campaign) {
      this.form = JSON.parse(JSON.stringify(campaign));
      this.form.language = "en";
      this.form.title = this.form.title.en;
      this.form.description = this.form.description.en;
      this.form.image_path = this.form.image_paths.en;
      this.form.vehicles = this.campaign.vehicles.map(iv => iv.id);
    },
    async uploadImage(image) {
      let uploadData = {
        path: "campaigns-en",
        file: image
      };
      uploadData = window.jsonToFormData(uploadData);
      const res = await uploadServices.post({
        data: uploadData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      if (res.error) {
        //error handling
        this.responseToast(
          "POST",
          "error",
          res,
          "fa-upload",
          "Fotoğraf yükleme"
        );
        return;
      }
      this.form.image_url = res.data.data.cdn_url;
      this.form.image_path = res.data.data.path;
      this.updateCampaign();
    },
    async updateCampaign() {
      const res = await campaignServices.put(this.campaignId, {
        data: this.form
      });
      if (res.error) {
        //error handling
        this.responseToast("PUT", "error", res);
        this.hasSaved = true;
        return;
      }
      this.responseToast("PUT", "success");
      this.hasSaved = true;
    },
    async onsubmit() {
      //validation
      if (!!this.image && JSON.stringify(this.image) !== JSON.stringify({})) {
        await this.resolveImage(s => {});
      } else {
        this.updateCampaign();
      }
    },
    handleFileInput() {
      this.deleteCroppaImage();
      this.$refs.campaignInputFileEn.click();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Lütfen resim dosyası seçiniz.");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          var img = {};
          img.url = URL.createObjectURL(file);
          img.name = file.name;
          this.image = img;
        };
        reader.readAsDataURL(file);
      }
    },
    rotateCroppaImage() {
      this.croppaImage = this.$refs.cropper.rotate(90);
    },
    deleteCroppaImage() {
      this.image = {};
      this.croppaImage = {};
    },
    async resolveImage(callback) {
      let file = null;
      if (!!this.image && JSON.stringify(this.image) !== JSON.stringify({})) {
        await this.$refs.cropper
          .getCroppedCanvas()
          .toBlob(blob => {
            file = new File([blob], "file_name", { lastModified: 1534584790000 });
            this.uploadImage(file);
            callback();
          });
      }
    }
  },
  created() {
    this.isMobile = this.checkIsMobile();
    if (this.$route.params.id) {
      this.campaignId = this.$route.params.id;
      this.getCampaign();
    }
  }
};
</script>